import { ShiftDifferentialType } from '~/types/hlx/enums';
import { JobListing } from '~/types/hlx/jobListing';
import { emptyShiftDetailsForm, SHIFT_DIFF_TYPE_OPTIONS } from './constants';
import { ShiftDetailsFormValues } from './types';

export const transformApiToShiftDetailsForm = (listing: JobListing): ShiftDetailsFormValues => {
  const shiftDiffTypeValue =
    listing.detail?.shiftDiffType || ShiftDifferentialType.INCR_HOURLY_RATE;
  const shiftDiffTypeOption =
    SHIFT_DIFF_TYPE_OPTIONS.find((option) => option.value === shiftDiffTypeValue) ||
    SHIFT_DIFF_TYPE_OPTIONS[0];

  return {
    ...emptyShiftDetailsForm,
    ...listing.detail,
    id: listing.detail?.id,
    jobListingId: listing.id,
    shiftDiffType: shiftDiffTypeOption,
  };
};

export const transformShiftDetailsFormToApi = (formValues: ShiftDetailsFormValues) => {
  const {
    id,
    jobListingId,
    numDayShifts,
    numEveShifts,
    numNightShifts,
    numOfWeDayShifts,
    numOfWeEveShifts,
    numOfWeNightShifts,
    numHolDayShifts,
    numHolEveShifts,
    numHolNightShifts,
    shiftDiffType,
    eveShiftRateDiff,
    nightShiftRateDiff,
    weDayShiftRateDiff,
    weEveShiftRateDiff,
    weNightShiftRateDiff,
    holDayShiftRateDiff,
    holEveShiftRateDiff,
    holNightShiftRateDiff,
  } = formValues;

  return JSON.stringify({
    id,
    jobListingId,
    numDayShifts,
    numEveShifts,
    numNightShifts,
    numOfWeDayShifts,
    numOfWeEveShifts,
    numOfWeNightShifts,
    numHolDayShifts,
    numHolEveShifts,
    numHolNightShifts,
    shiftDiffType: shiftDiffType.value,
    eveShiftRateDiff,
    nightShiftRateDiff,
    weDayShiftRateDiff,
    weEveShiftRateDiff,
    weNightShiftRateDiff,
    holDayShiftRateDiff,
    holEveShiftRateDiff,
    holNightShiftRateDiff,
  });
};
